import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next"; // Dodajte ovo za korišćenje useTranslation hook-a

const LessonsArchive = () => {
  const { educationItemsList, educationItemsLessonsList } = useSelector(
    (state) => state.educationReducer
  );

  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation(); // Koristite useTranslation za prevođenje

  // Ako `educationItemsList` nije učitan, preusmeravamo korisnika
  useEffect(() => {
    if (!educationItemsLessonsList) {
      navigate("/education-list");
    }
  }, [educationItemsLessonsList, navigate]);

  // Provera da li `educationItemsList` ima validne podatke
  if (!educationItemsLessonsList) {
    return null;
  }

  const handleNext = () => {
    if (activeStep < educationItemsLessonsList?.length - 1) {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const handleStartTest = () => {
    navigate("/education-list"); // Preusmeravanje na stranicu sa pitanjima
  };

  return (
    <div className="education-lesson-main-content education-lesson-main-content-archive">
      {/* Sadržaj koraka */}
      <div className="education-lesson-content">
        <div className="education-lesson-content-text-title">
          {educationItemsLessonsList[activeStep]?.name}
        </div>
        <div className="education-lesson-content-image">
          <img
            src={educationItemsLessonsList[activeStep]?.image}
            className="img-fluid"
          />
        </div>
        <div className="education-lesson-content-text">
          <div
            className="education-lesson-content-text-description"
            dangerouslySetInnerHTML={{
              __html: educationItemsLessonsList[activeStep]?.description,
            }}
          ></div>
        </div>
      </div>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingTop: 3,
          marginBottom: 15,
          gap: 2,
        }}
      >
        {activeStep < educationItemsLessonsList?.length - 1 && (
          <Button
            className="next-step-lesson-button w-100"
            onClick={handleNext}
          >
            {t("lessons.nextLesson")}
          </Button>
        )}

        {activeStep === educationItemsLessonsList?.length - 1 && (
          <Button className="start-quiz-button" onClick={handleStartTest}>
            {t("lessons.exitLesson")}
          </Button>
        )}
        {activeStep > 0 && (
          <Button className="prev-step-lesson-button" onClick={handleBack}>
            {t("lessons.previousLesson")}
          </Button>
        )}
      </Box>
    </div>
  );
};

export default LessonsArchive;
